// React libraries
import React from "react";

// React Google Charts
import { Chart as GoogleChart } from "react-google-charts";

export const Chart = (props) => {
    const { id = "", chartType = "ColumnChart", chartData, chartWidth, chartHeight,
        chartOptions, chartEvents, useLegendToggle = false, style, mapsApiKey = '', rootProps = null } = props

    return (
        <div
            id={id}
            style={style}
        >
            <GoogleChart
                loader={<div>{"Loading Chart"}</div>}
                chartType={chartType}
                data={chartData}
                width={chartWidth}
                height={chartHeight}
                options={chartOptions}
                chartEvents={chartEvents}
                legendToggle={useLegendToggle}
                mapsApiKey={mapsApiKey}
                rootProps={rootProps}
            />
        </div>
    )
}

export default React.memo(Chart);